import { render } from "./PeriodStats.vue?vue&type=template&id=e438a7e2&scoped=true"
import script from "./PeriodStats.vue?vue&type=script&lang=js"
export * from "./PeriodStats.vue?vue&type=script&lang=js"

import "./PeriodStats.vue?vue&type=style&index=0&id=e438a7e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e438a7e2"]])

export default __exports__